<coin-v2-dialog-frame [header]="data.translationPrefix + 'view-information-headline' | translate">
  <div class="body-container">
    <p>
      {{ data.translationPrefix + 'view-information-message' | translate }}
    </p>
  </div>
  <coin-v2-dialog-footer color="white">
    <coin-v2-button
      type="outline"
      icon="close"
      iconPos="right"
      [text]="'general.close' | translate"
      (click)="closeDialog()"></coin-v2-button>
  </coin-v2-dialog-footer>
</coin-v2-dialog-frame>
